// Footer.js
import React from 'react';
import './App.css'; // Make sure to create a corresponding CSS file for styling

function Footer() {
  return (
    <footer className="footer">
      <p>Contact us: prosolution(at)gmail.com || {new Date().getFullYear()} ProSolution. All rights reserved. </p>
    </footer>
  );
}

export default Footer;